import React, { useState } from "react";
import {
  Box,
  Container,
  Typography,
  Collapse,
  IconButton,
  Stack,
  Button,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import { useNavigate } from "react-router-dom";

const faqs = [
  {
    question: "Who is this coaching for?",
    answer:
      "This program is designed for sales professionals, founders, and teams handling high-value or high-ticket deals.",
  },
  {
    question: "Is this industry-specific?",
    answer:
      "No. The sales psychology and frameworks apply across industries — real estate, luxury products, services, and more.",
  },
  {
    question: "How are sessions conducted?",
    answer:
      "Sessions are conducted live online and/or in person, depending on the program you choose",
  },
  {
    question: "How soon will I see results?",
    answer:
      "Most participants start noticing clarity and improved conversations within the first few weeks.",
  },
  {
    question: "Do you offer corporate or team programs?",
    answer:
      "Yes. We offer customized training programs tailored for organizations and sales teams.",
  },
];

const FaqSection: React.FC = () => {
  const [active, setActive] = useState<number | null>(0);
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        py: 6,
        background: "linear-gradient(180deg, #ffffff 0%, #f2f8ff 100%)",
        borderTop: "2px solid rgba(15,99,165,0.15)",
      }}
    >
      <Container maxWidth="md">
        {/* Header */}
        <Box textAlign="center" mb={6}>
          <Typography
            variant="h3"
            fontWeight={800}
            sx={{ color: "#0f63a5" }}
            gutterBottom
          >
            Frequently Asked Questions
          </Typography>
          <Typography color="text.secondary">
            Everything You Need to Know About Our Sales Coaching Programs
          </Typography>
        </Box>

        {/* FAQ List */}
        <Stack spacing={3}>
          {faqs.map((faq, index) => {
            const isOpen = active === index;

            return (
              <Box
                key={index}
                sx={{
                  backgroundColor: "white",
                  borderRadius: "16px",
                  p: 2,
                  borderLeft: isOpen
                    ? "5px solid #0f63a5"
                    : "5px solid transparent",
                  boxShadow: isOpen
                    ? "0 15px 40px rgba(15,99,165,0.15)"
                    : "0 5px 15px rgba(0,0,0,0.04)",
                  transition:
                    "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
                    "&:hover": {
                  border: "1px solid #0f63a5",
                  boxShadow:
                    "0 12px 35px rgba(15,99,165,0.12)",
                },
                "&:before": { display: "none" },
                }}
              >
                {/* Question Row */}
                <Stack
                  direction="row"
                  justifyContent="space-between"
                  alignItems="center"
                  onClick={() =>
                    setActive(isOpen ? null : index)
                  }
                  sx={{ 
                    cursor: "pointer" ,
                    
                }}
                >
                  <Typography
                  variant="body1"
                    fontWeight={600}
                    sx={{
                      color: isOpen ? "#0f63a5" : "#111",
                      fontSize:{xs:'18px !important',md:"20px" }
                    }}
                  >
                    {faq.question}
                  </Typography>

                  <IconButton
                    sx={{
                      color: "#0f63a5",
                    }}
                  >
                    {isOpen ? <RemoveIcon /> : <AddIcon />}
                  </IconButton>
                </Stack>

                {/* Answer */}
                <Collapse in={isOpen}>
                  <Typography
                  variant="body2"
                    sx={{
                      mt: 1,
                      color: "rgba(0,0,0,0.65)",
                      lineHeight: 1.8,
                      textAlign:'start',
                      fontSize:{xs:'16px !important',md:"20px" }

                    }}
                  >
                    {faq.answer}
                  </Typography>
                </Collapse>
              </Box>
            );
          })}
        </Stack>

        <Box textAlign="center" mt={5}>
  <Button
    variant="contained"
    onClick={() => navigate("/faqs")}
    sx={{
      backgroundColor: "#0f63a5",
      borderRadius: "30px",
      px: 4,
      py: 1.5,
      fontWeight: 600,
      textTransform: "none",
      "&:hover": {
        backgroundColor: "#0c4e82",
        color:'white'
      },
    }}
  >
    View All FAQs
  </Button>
</Box>
      </Container>
    </Box>
  );
};

export default FaqSection;
